import React, { useContext, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import { PartnersContext } from 'pages/Partners/PartnersList/context';
import { Search } from 'common/Search';
import { BookingsContextDetail } from 'pages/Bookings/components/BookingDetail/bookingContextDetail';

interface ChefAssignProps {
  show: boolean;
  bookingId: string | null;
  onClose: () => void;
}

const ChefAssignModel: React.FC<ChefAssignProps> = ({
  show,
  bookingId,
  onClose,
}) => {
  const [selectedChefId, setSelectedChefId] = useState<string | null>(null);

  const partnerContext = useContext(PartnersContext);
  const bookingContext = useContext(BookingsContextDetail)

  if (!partnerContext) {
    throw new Error(
      'ChefAssignModel must be used inside PartnersContextProvider'
    );
  }

  if(!bookingContext){
    throw new Error('ChefAssignModel must be used inside BookingsDetailProvider')
  }

  const { assignChef } = bookingContext;

  const {
    partnersData,
    handleSearchChange,
    handleClearSearch,
    searchKeyword,
  } = partnerContext;

  const { isLoading, data: chefs } = partnersData;
  console.log(  'Chefs from context in ChefAssignModel:', chefs);

    console.log('Chef ID:', selectedChefId);


  const handleSubmit = async() => {
    if (!selectedChefId) {
      toast.warning('Please select a chef');
      return;
    }

    if (!bookingId) {
      toast.error('Invalid booking');
      return;
    }

    console.log('Booking ID:', bookingId);
    try {
      await assignChef(selectedChefId);
      toast.success('chef assigned successfully')
      onClose()
    } catch (error) {
       toast.error('Failed to assign chef');
    }

    onClose();
  };

  return (
    <Modal
      isOpen={show}
      toggle={onClose}
      centered
      className="modal-dialog-scrollable"
    >
      <ModalHeader toggle={onClose}>Assign Chef</ModalHeader>

      <ModalBody>
        {/* 🔍 SEARCH */}
        <div className='mb-3' >
        <Search
          searchKeyword={searchKeyword ?? ''}
          onSearch={handleSearchChange}
          onClearSearch={handleClearSearch}
        />
        </div>


        {isLoading && <p className="mt-2">Loading chefs...</p>}

        {!isLoading &&
          chefs.map((chef) => (
            <div
              key={chef.id}
              onClick={() => setSelectedChefId(chef.id)}
              style={{
                padding: '0px 10px',
                cursor: 'pointer',
                borderRadius: '6px',
                    fontSize: '12px',
                marginTop: '6px',
                background:
                  selectedChefId === chef.id ? '#fff5f5' : 'transparent',
                border:
                  selectedChefId === chef.id
                    ? '1px solid #d02429'
                    : '1px solid transparent',
              }}
            >
              {chef.firstName} {chef.lastName}
            </div>
          ))}
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          disabled={!selectedChefId}
          onClick={handleSubmit}
        >
          Assign
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ChefAssignModel;